export default __webpack_public_path__ + "static/media/Foto-395-300x200.82c921d0.png";